import { apiGet } from '@/shared/utils/requestBuilder';
import type { PlataformaLogsResponse } from '../../types/plataforma';

export const plataformaLogsService = {
  getLogs: async (): Promise<PlataformaLogsResponse> => {
    const response = await apiGet('/admin/platform/logs');
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.error?.message ?? 'Erro ao carregar logs da plataforma');
    }

    return data.data as PlataformaLogsResponse;
  },
};
